<template>
  <div class="row logged-user-header navbar navbar-expand-lg navbar-light bg-light">
    <div class="col">
      <router-link to="/">Accueil</router-link>
      <router-link to="/lobby" v-if="username">Salon</router-link>
      <router-link to="/rating">Scores</router-link>
      <router-link to="/salle" class="d-none d-md-inline" v-if="username">Tournoi en salle</router-link>
      <router-link to="/rules" class="d-none d-md-inline">Règles</router-link>
      <router-link to="/contact" v-if="username">Contact</router-link>
      <bs-dropdown text="Admin" size="sm" variant="link" right offset="-15" v-if="role === 'admin'">
        <bs-dropdown-item to="/admin/users">Joueurs</bs-dropdown-item>
        <bs-dropdown-item to="/admin/cognitousers">Utilisateurs à confirmer</bs-dropdown-item>
        <bs-dropdown-item to="/admin/payments">Paiements</bs-dropdown-item>
        <bs-dropdown-item to="/admin/statistics">Statistiques</bs-dropdown-item>
      </bs-dropdown>
    </div>
    <div class="col-3 text-end" v-if="username">
      <bs-dropdown :text="username" size="sm" variant="link" right offset="-15">
        <li class="text-center">
          <img v-bind:src="picture" v-if="picture" width="96"/>
          <img src="../assets/default-profile.png" v-else width="96"/>
        </li>
        <bs-dropdown-item to="/profile">Mon compte</bs-dropdown-item>
        <bs-dropdown-item to="/support" v-if="role === 'user'">Adhérer à LCT</bs-dropdown-item>
        <bs-dropdown-item to="/support" v-if="role === 'premium' || role === 'admin'">
          Soutenir LCT</bs-dropdown-item>
        <bs-dropdown-item @click="logout">Déconnexion</bs-dropdown-item>
      </bs-dropdown>
    </div>
  </div>
</template>

<script>
import iam from '../iam';
import BsDropdown from './ui/BsDropdown.vue';
import BsDropdownItem from './ui/BsDropdownItem.vue';

export default {
  name: 'Logged-User',
  components: { BsDropdown, BsDropdownItem },
  data() {
    return {
      picture: iam.getConnectedUser() ? iam.getConnectedUser().picture : undefined,
      role: iam.getConnectedUser() ? sessionStorage.getItem('userrole') : undefined,
      username: iam.getConnectedUser() ? iam.getConnectedUser().username : undefined,
    };
  },
  methods: {
    logout() {
      iam.logout();
      this.$router.push('/?logout');
    },
  },
};
</script>

<style>
.logged-user-header .dropdown-toggle::after {
    vertical-align: 0.155em;
}
.navbar a{
  font-size: 0.8rem;
  color: black;
  margin-right: 16px;
}
.navbar li a{
  margin-right: 0;
  font-size: 1rem;
}
.navbar .dropdown-item:hover, .dropdown-item:focus {
    color: #16181b;
    text-decoration: none;
    background-color: white;
}
.navbar{
  padding: 0;
}
.navbar .b-dropdown ul {
  background-color: #f8f9fa;
}
</style>
